var customEvent = require('../constants/customEvent')

// Namespaced keys shared with the React PayNow OAuth util. The presence of the return-URL key (written
// immediately before the full-page redirect and cleared here on consume) is the discriminator between
// the new full-page PayNow flow and the legacy StripeModalsGroup popup flow — never fall back to mere
// param presence, or a stale key could hijack the popup's postMessage handshake.
var paynowOAuthReturnUrlKey = 'billy-paynow-oauth-return-url'
var paynowOAuthPendingKey = 'billy-paynow-oauth-pending'

module.exports = Em.Route.extend({
    model: function(params) {
        var paynowReturnUrl = sessionStorage.getItem(paynowOAuthReturnUrlKey)

        if (paynowReturnUrl) {
            sessionStorage.removeItem(paynowOAuthReturnUrlKey)

            if (params.code) {
                sessionStorage.setItem(
                    paynowOAuthPendingKey,
                    JSON.stringify({
                        authorizationSuccess: {
                            code: params.code,
                            scope: params.scope,
                            state: params.state
                        }
                    })
                )
            } else if (params.error) {
                sessionStorage.setItem(
                    paynowOAuthPendingKey,
                    JSON.stringify({
                        authorizationFailure: {
                            error: params.error,
                            error_description: params.error_description,
                            state: params.state
                        }
                    })
                )
            }

            window.location.replace(paynowReturnUrl)
            return new Em.RSVP.Promise(function() {})
        }

        var result
        if (params.error) {
            result = { type: 'error', message: decodeURIComponent(params.error_description.replace(/\+/g, '%20')) }
        } else {
            result = { type: 'success', code: params.code }
        }
        window.addEventListener('message', function(event) {
            if (event.data.message === customEvent.StripeIntegrationRequestResult) {
                // event.source is the opener
                event.source.postMessage({ message: customEvent.StripeIntegrationDeliverResult, result: result }, '*')
            }
        })
        return new Em.RSVP.Promise(function() {
            // Never resolve
        })
    }
})
